import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IParams {
	channelId: string;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean;
}

const LazyDevLog = lazy(() => import(/* webpackChunkName: "Channel" */ "./Channel"));

const ChannelPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, channelId, path } = props;

	if (!loggedIn) {
		return <></>;
	}

	const channelIdNum = channelId === "" ? undefined : Number(channelId);

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyDevLog channelId={channelIdNum} />
	</ErrorBoundary>;
};

export default ChannelPage;